// コース割当人数 vs コース別受付人数(min/max)の純粋検証。
// client(finishWork) と api(ToretaService.validateCourseNumberOfPersons) から共用する。

export interface CoursePersonLimit {
  numberOfPersonsMin?: number | null;
  numberOfPersonsMax?: number | null;
}

export interface CourseCountInput {
  id: string;
  count: number;
}

export interface CourseCountViolation {
  courseId: string;
  kind: "min" | "max";
  limit: number;
}

/**
 * count > 0 の各コースについて、min/max を独立に評価する。
 * 最初に見つかった違反を返し、違反が無ければ null。
 * limit(min/max) が falsy(0/null/undefined) の側は制限なし扱い。
 */
export function findCoursePersonCountViolation(
  courses: CourseCountInput[],
  limits: Record<string, CoursePersonLimit>
): CourseCountViolation | null {
  for (const course of courses) {
    if (!course || course.count <= 0) continue;
    const limit = limits[course.id];
    if (!limit) continue;

    const min = limit.numberOfPersonsMin;
    if (min && min > 0 && course.count < min) {
      return { courseId: course.id, kind: "min", limit: min };
    }

    const max = limit.numberOfPersonsMax;
    if (max && max > 0 && course.count > max) {
      return { courseId: course.id, kind: "max", limit: max };
    }
  }
  return null;
}
